var Raphael = require('raphael'),
	GraphicShape = require('./graphic'),
	BottomTxtUIModel = require('../views/shape/signature/bottomText/uiModel');


module.exports = GraphicShape.extend({

	//export as 2 shapes -- will be recognized on import and drawn as one

	hasCustomizableProperties: 1,

	ALLOW_DRAG_OFF_CANVAS: 1,

	getNormalizedElToPerist: function() {

		var sigEl = GraphicShape.prototype.getNormalizedElToPerist.apply(this, arguments);
		var bt = this.bottomText;

		if (!bt)
			return sigEl;


		/**
		 * Bottom text -- also return to add to set of shapes to save
		 * DVBC-1823 - bakeTransform: when scale changes we don't bake in the transform ( we do on move ) --
		 * Utilize existing bake function on the element so the persisted path takes the transform into account.
		 * Could check for existance of transform and split bakeTransform R.el function to use a separate function that would
		 * return a path if we continue using Raphael in the future.
		 */
		bt.el.bakeTransform();

		var btPath = Raphael.fn.viewerUnadjustedPath.apply( Raphael.fn, [bt.el.attr('path')].concat( _.toArray(arguments)) );

		//TODO: util --
		var btClone = bt.el.clone();
		btClone.attr('path', btPath);
		btClone.attrs =  _.omit(btClone.attrs, 'cursor'); //remove any cursor attribute on the clone (don't want persisted)
		//the original will be removed on destroy called after save -- and left if there is an error

		return [sigEl, btClone];

	},

	// Don't auto-render the shape because if there is the 'bottom text',
	// combine it into the path of the this shape.
	// The bottom text is stored as a prop on the model, not merged with the path of the shape.
	// (It's stored to know it's position, for re-render with derived values in it's old position, without already rendering).

	getPathToRenderFromModel: function(scale) {

		var signaturePath = GraphicShape.prototype.getPathToRenderFromModel.apply (this, arguments );

		var btModel = this.parentNote.bottomTextModel; //(flag from shapeModelsToRender)

		if (btModel) {

			var btP = this._getDerivedBottomTextPathFromModel( btModel.origSVGAttrs, scale ); // (takes state into acct)

			btModel.origSVGAttrs.path = btP;  //eh -- rid?

			signaturePath = signaturePath.concat(btP);
			this.origSVGAttrs.path = signaturePath; //(what is then rendered, if called from shape render) //rid(?)
		}

		return signaturePath;

	},

	_getDerivedBottomTextPathFromModel: function( originalBTAttrs, scale ) {

		var btPathAdjusted = Raphael.fn.viewerAdjustedPath(
			originalBTAttrs.path,
			scale,
			this.pageModel.get('rotation'),
			this.pageModel.getOriginalCenterPtRotated(scale)
		);

		originalBTAttrs.path = btPathAdjusted;  // TODO: still necessary?

		return btPathAdjusted;



	}


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/canvas/models/signature.js
 ** module id = 297
 ** module chunks = 0
 **/